
export default {
  name: 'ScrollProgressBar',

  data() {
    return {
      progress: 0,
    }
  },

  mounted() {
    window.addEventListener('scroll', this.updateProgress, { passive: true })
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.updateProgress)
  },

  methods: {
    updateProgress() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop
      const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight

      // Avoid divide-by-zero on short pages
      this.progress = docHeight > 0 ? Math.min((scrollTop / docHeight) * 100, 100) : 0
    },
  },
}
